import React, { useEffect } from 'react';
import { Form } from '@formio/react';
import useOperations from './FormAdmProcFunctions';
import { options } from '../FormNuevaSolicitud/FormNuevaSolicitudData';
import FormAdmProcStyle from './FormAdmProcStyle.css';
import FormioFunctions from '../Precargas/FormIoFunctions';

export default function FormRecurso(props) {
    const { formData, getResource, handleCustomEvents } = useOperations(props);
    const {obtenerUrlContexto} = FormioFunctions();

    useEffect(() => {
        getResource(props.aliasFormulario);
    }, []);


    return (
        <div>
            {/*A la etiqueta options hay que pasarle los parametros directamente, 
            NO creamos una constante. En caso de hacerlo se producirá un BUG y se harán multiples 
            llamadas al onSubmit y al onChange*/}
            <Form
                form={formData}
                onSubmit={props.onSubmit}
                options={{
                    ov: true,
                    language: 'sp',
							i18n: {
                                sp: {
                                    complete: 'Formulario cumplimentado correctamente',
                                    error: 'Hubo un problema',
                                    next: 'Siguiente',
                                    previous: 'Atrás',
                                    cancel: 'Cancelar',
                                    submit: 'FINALIZAR E IR AL PASO 2',
                                    required: 'Es obligatorio rellenar este campo',
                                    confirmCancel: '¿Estás seguro que quieres cancelar?',
                                    submitError: 'Por favor revise el formulario y corrija todos los errores.'
                                    }
                                }, evalContext: {
                                    // Funciones auxiliares
                                    obtenerUrlContexto: obtenerUrlContexto
                                }
            
            }}
                onChange={props.onChange}
                submission={props.submission}
                onCustomEvent={handleCustomEvents}            
            />
        </div>
    );
}